import React from "react"
import { IHierarchyJobFilterEntry, IJobDocument } from "../../models"
import strings from "../../localization/strings"
import { Chip, IconButton, FontIcon } from "material-ui"
import ChooseHierarchyPickerDialog from "../hierarchy/choose_hierarchy/ChooseHierarchyPickerDialog"
import AddJobDialogForChip from "../job/AddJobDialogForChip"
import AccountStore from "../../stores/AccountStore"
import { checkJobFieldAvailable } from "../../helpers/jobHelper"

interface IProps {
    hierarchyJobs: IHierarchyJobFilterEntry[]
    handleChange(hierarchyJobs: IHierarchyJobFilterEntry[]): void
}
interface IState {
    openHierarchyDialog: boolean
    openJobDialog: boolean
    clickedHierarchyId: string
    clickedHierarchyIndex: number
}

export default class ChooseHierarchyJobSelector extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            openHierarchyDialog: false,
            openJobDialog: false,
            clickedHierarchyId: null,
            clickedHierarchyIndex: null
        }
    }

    render() {
        return (
            <div style={{ marginTop: 10 }}>
                <div>{strings.Employee_Default_Hierarchy}</div>
                <div style={{ display: "flex",  flexWrap: "wrap" }}>
                    {this.props.hierarchyJobs.map((hierarchyJob, index) =>
                        <div style={{ display: "flex",  flexWrap: "wrap" }} key={`${hierarchyJob.HierarchyId}-${hierarchyJob.JobId}`}>
                            <Chip
                                title={hierarchyJob.JobName ? strings.Click_To_Select_Job : ""}
                                style={{ margin: 5, cursor: "pointer" }}
                                deleteIconStyle={{ marginLeft: 5 }}
                                onClick={() => AccountStore.getJobsEnabled() && hierarchyJob.JobName &&
                                    this.setState({ openJobDialog: true, clickedHierarchyId: hierarchyJob.HierarchyId, clickedHierarchyIndex: index })
                                }
                                onRequestDelete={() => this.props.handleChange(this.props.hierarchyJobs.filter((i, itemIndex) => index !== itemIndex))}
                            >
                            {AccountStore.getJobsEnabled() ?
                                <div style={{ display: "flex" }}>
                                    <p style={{ margin: 0 }}>{`${strings.Hierarchy}: ${hierarchyJob.HierarchyName}  |  ${hierarchyJob.JobName ? checkJobFieldAvailable('singular') ? `${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}` : strings.Job + ": " + hierarchyJob.JobName :  checkJobFieldAvailable('singular') ? `Choose ${AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}` : "Choose Job"}`}</p>
                                    {!hierarchyJob.JobName &&
                                        <IconButton
                                            style={{ height: 15, width: 15, padding: 0, margin: 0, display: "inline-block" }}
                                            iconStyle={{ fontSize: 20, marginTop: 6, marginLeft: 5 }}
                                            onTouchTap={() => this.setState({ openJobDialog: true, clickedHierarchyId: hierarchyJob.HierarchyId, clickedHierarchyIndex: index })}
                                        >
                                            <FontIcon className="fa fa-plus-circle" />
                                        </IconButton>
                                    }
                                </div>
                            :
                            `${strings.Hierarchy}: ${hierarchyJob.HierarchyName}`
                            }
                            </Chip>
                        </div>
                    )}
                    <IconButton
                        style={{ height: 35, width: 35, padding: 0, margin: 0, display: "inline-block" }}
                        onTouchTap={() => this.setState({ openHierarchyDialog: true })}
                    >
                        <FontIcon className="fa fa-plus-circle" />
                    </IconButton>
                </div>
                {this.state.openHierarchyDialog &&
                    <ChooseHierarchyPickerDialog
                        handleSave={hierarchy => {
                            const hierarchyJob = (hierarchy ? { HierarchyId: hierarchy.Id, HierarchyName: hierarchy.Label } : null) as IHierarchyJobFilterEntry
                            hierarchyJob &&
                                this.props.handleChange([...this.props.hierarchyJobs, hierarchyJob])
                        }}
                        handleClose={() => this.setState({ openHierarchyDialog: false })}
                        getCustomNoAccessErrorStr={hierarchyItem =>
                            this.props.hierarchyJobs &&
                            this.props.hierarchyJobs.find(i => i.HierarchyId === (hierarchyItem ? hierarchyItem.Id : null)) &&
                            strings.Hierarchy_Item_Selected
                        }
                    />
                }
                {this.state.openJobDialog &&
                    <AddJobDialogForChip
                        jobs={this.props.hierarchyJobs.map(item => { return { Id: item.JobId, Name: item.JobName, HierarchyId: item.HierarchyId } as IJobDocument })}
                        filterHierarchyId={this.state.clickedHierarchyId}
                        multiSelectable={false}
                        restrictHierarchy
                        handleClose={() => this.setState({ openJobDialog: false })}
                        handleSave={selectedJobs => {
                            const job = selectedJobs.length > 0 ? { JobId: selectedJobs[0].Id, JobName: selectedJobs[0].Name } : null
                            let hierarchyJobs = this.props.hierarchyJobs
                            if (job) {
                                hierarchyJobs[this.state.clickedHierarchyIndex]["JobId"] = job.JobId
                                hierarchyJobs[this.state.clickedHierarchyIndex]["JobName"] = job.JobName
                            }
                            this.props.handleChange(hierarchyJobs)
                            this.setState({ openJobDialog: false })
                        }}
                    />
                }
            </div>
        )
    }
}